import React from 'react';
import PropTypes from 'prop-types';

import AsyncSelect from 'react-select/async';

const loadOptions = async (query) => {
    try {
        const response = await fetch(`/api/cities/${query}`);
        const json = await response.json();

        return json.data;
    } catch (error) {
        return [];
    }
};

const HomepageSearch = props => (
    <AsyncSelect
        className="homepage-search__input"
        type="search"
        classNamePrefix="homepage-search-input"
        name="q"
        aria-label="Zoek uw droomwoning op gemeente of referentie"
        placeholder="Zoek uw droomwoning op gemeente of referentie"
        cacheOptions
        defaultOptions
        isClearable={false}
        loadOptions={loadOptions}
        getOptionValue={option => option.postalCode}
        getOptionLabel={option => `${option.postalCode} ${option.name}`}
        onChange={ option => window.location.href = `/pages/search?q=${option.postalCode}` }
    />
);

export { HomepageSearch };
